import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.link.js";
import { isTokenExpired } from "@/js/http/auth.js";
export default {
  name: "Error",
  data: function data() {
    return {
      heyror: {},
      customerServiceLink: "/contact"
    };
  },
  props: ["error", "loggedUserData", "darkBg"],
  created: function created() {
    this.heyror = _objectSpread({}, this.error);
    if (!this.heyror.title) {
      this.heyror.title = "page not found";
    }
    if (!this.heyror.linkTitle) {
      this.heyror.linkTitle = "Go";
    }
    if (!this.heyror.link) {
      this.heyror.link = "userHome";
    }
    if (isTokenExpired() == false) {
      this.customerServiceLink = "/user/contact";
    }
  },
  methods: {
    goToLink: function goToLink() {
      if (!isTokenExpired()) {
        var _this$heyror$params;
        var query = (_this$heyror$params = this.heyror.params) !== null && _this$heyror$params !== void 0 && _this$heyror$params.tab ? {
          tab: this.heyror.params.tab
        } : null;
        this.$router.push({
          name: this.heyror.link,
          query: query
        });
      } else {
        this.$router.push({
          name: "home"
        });
      }
    }
  }
};